import "./index.css";

function Footer() {
  return (
      <div className="footer footer-padding">
        <div className="footer-content">
          <p className="footer-p">Made with ❤️ by L & A Studio</p>
        </div>
      </div>
  );
}

export default Footer;
